import { supabase } from "@/lib/supabase";

export type ProfileDisplayFields = {
  name?: string | null;
  full_name?: string | null;
  email?: string | null;
};

export function emailLocalPart(email: string | null | undefined): string | null {
  if (!email) return null;
  const part = email.split("@")[0]?.trim();
  return part || null;
}

/** e.g. "jerome.mockel" -> "Jerome Mockel" */
export function humanizeEmailPrefix(localPart: string): string {
  const trimmed = localPart.trim();
  if (!trimmed) return "Mitglied";
  return trimmed
    .split(/[._]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
}

export function resolveDisplayName(profile: ProfileDisplayFields | null | undefined): string {
  const fullName = profile?.full_name?.trim();
  if (fullName) return fullName;

  const name = profile?.name?.trim();
  if (name) return name;

  const local = emailLocalPart(profile?.email);
  if (local) return humanizeEmailPrefix(local);

  return "Mitglied";
}

export async function fetchProfileMap(userIds: string[]) {
  const unique = [...new Set(userIds.filter(Boolean))];
  const map = new Map<
    string,
    ProfileDisplayFields & { id: string; avatar_url?: string | null }
  >();
  if (unique.length === 0) return map;

  const { data, error } = await supabase.rpc("get_profile_displays", {
    p_user_ids: unique,
  });

  if (error) throw error;

  for (const profile of data ?? []) {
    if (!profile.id) continue;
    map.set(profile.id, { ...profile, id: profile.id });
  }
  return map;
}
